import Layout from '@/components/Layout';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQPage() {
  const faqSections = [
    {
      title: "General Questions",
      icon: "🧾",
      questions: [
        {
          q: "What does a physiotherapist do?",
          a: "A physiotherapist helps people restore movement, reduce pain, and improve strength after injury, surgery, or illness. We use hands-on techniques, exercise programs, and education to support your recovery and long-term health."
        },
        {
          q: "Do I need a doctor's referral to see a physiotherapist?",
          a: "No referral is needed. You can book directly with Bong/office or via the Book appointment link. Some medical aids however, may require a referral for reimbursement if you pay cash."
        },
        {
          q: "How long is a typical physiotherapy session?",
          a: "Sessions usually last between 30–45 minutes. Home visits may last between 45-60 minutes. Sessions may depend on your condition and treatment plan. Sports Massages are typically 30mins."
        },
        {
          q: "How many sessions will I need?",
          a: "This varies from person to person. Some patients feel better after just a few visits, while others with complex conditions may need ongoing care. We will discuss your goals and create a plan tailored to you."
        },
        {
          q: "What should I wear to my appointment?",
          a: "Comfortable clothing that allows easy movement is best. If we're treating a specific area (like your knee or shoulder), wear something that makes it easy to access."
        },
        {
          q: "What conditions do you treat?",
          a: "We treat a wide range of conditions including neurological conditions, cardiothoracic recovery, sports injuries, post-surgical rehabilitation, back and neck pain."
        }
      ]
    },
    {
      title: "Costs & Insurance",
      icon: "💰",
      questions: [
        {
          q: "How much does a physiotherapy session cost?",
          a: "Our fees vary depending on the type and duration of treatment. We charge medical aid rates. Cash paying patients are charged between R650 to R750 per session. R900 for home visits. We can provide a clear breakdown before your first appointment."
        },
        {
          q: "Do you accept medical aid/insurance?",
          a: "Yes, we work with most major medical aids. Please check with your provider if you are covered for physio treatments."
        },
        {
          q: "What payment options are available?",
          a: "We accept cash, card, and EFT payments. For medical aid claims, we can submit directly on your behalf if your plan allows. Please note that it is always the patient's responsibility to settle their account."
        },
        {
          q: "Will my insurance cover physiotherapy?",
          a: "Coverage depends on your plan. We recommend contacting your medical aid to confirm if your benefits cover physio."
        }
      ]
    },
    {
      title: "Treatment & Recovery",
      icon: "🏥",
      questions: [
        {
          q: "What happens during my first appointment?",
          a: "Bong will start with a detailed assessment of your condition, medical history, and goals. Then she will explain your treatment plan and begin therapy right away if appropriate."
        },
        {
          q: "Will the treatment be painful?",
          a: "Some techniques may cause mild discomfort, especially if you're recovering from surgery or injury. Bong always works within your tolerance and will explain everything as the session goes."
        },
        {
          q: "How soon will I start to feel better?",
          a: "Many patients notice improvement within a few sessions, but recovery time depends on your condition and commitment to your exercise program."
        },
        {
          q: "Do you provide home exercise programs?",
          a: "Yes. Bong will give you tailored exercises to continue at home, which are key to speeding up recovery."
        },
        {
          q: "Do you offer home visits?",
          a: "Yes, home visits can be arranged for patients within Johannesburg North and West Rand area."
        },
        {
          q: "What should I bring to my first appointment?",
          a: "Please bring any relevant medical reports, X-rays, or scans, along with a list of medications you're taking."
        },
        {
          q: "How do I book or reschedule an appointment?",
          a: "You can book online, call us directly, WhatsApp or email Bong directly. If you need to reschedule, just let us know at least 3 hours in advance."
        }
      ]
    }
  ];

  return (
    <Layout>
      {/* Hero Section - Turquoise */}
      <section className="py-16 bg-[#5ce1e6]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4 animate-fade-in" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Frequently Asked Questions
          </h1>
          <p className="text-lg text-slate-800 max-w-2xl">
            Find answers to common questions about our physiotherapy services
          </p>
        </div>
      </section>

      {/* Separator Line */}
      <div className="border-t-4 border-slate-400 w-full"></div>

      {/* FAQ Sections - White */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {faqSections.map((section, sectionIndex) => (
            <div key={sectionIndex} className="mb-12 animate-fade-in" style={{ animationDelay: `${sectionIndex * 100}ms` }}>
              <h2 className="text-2xl font-bold text-slate-800 mb-6 flex items-center gap-3" style={{ fontFamily: 'Manrope, sans-serif' }}>
                <span>{section.title}</span>
              </h2>
              
              <Accordion type="single" collapsible className="space-y-3">
                {section.questions.map((item, index) => (
                  <AccordionItem 
                    key={index} 
                    value={`${sectionIndex}-${index}`}
                    className="bg-white rounded-xl border border-slate-100 shadow-sm overflow-hidden"
                  >
                    <AccordionTrigger 
                      className="px-6 py-4 text-left hover:bg-slate-50 faq-trigger"
                      data-testid={`faq-trigger-${sectionIndex}-${index}`}
                    >
                      {item.q}
                    </AccordionTrigger>
                    <AccordionContent className="px-6 pb-4 text-slate-600">
                      {item.a}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          ))}
        </div>
      </section>
    </Layout>
  );
}
